import { useCallback, useMemo, useState } from 'react'
import { createFileRoute, useSearch } from '@tanstack/react-router'

const ConfirmSignupPage = () => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const params = useSearch({ from: '/auth/confirm-signup' }) as {
    confirmation_url: string
  }
  const confirmationUrl = params.confirmation_url

  // this is necessary because supabase does not allow us to customise the redirect url in
  // their invitation templates, so we do it here
  const redirectUrl = useMemo(() => {
    if (!confirmationUrl) return null
    const url = new URL(confirmationUrl)
    const params = new URLSearchParams(url.search)
    params.set('redirect_to', `${params.get('redirect_to')}/auth/set-password`)
    url.search = params.toString()
    return url.toString()
  }, [confirmationUrl])

  const [isClicked, setIsClicked] = useState(false)
  const handleConfirm = useCallback(() => {
    if (isClicked) return // Prevent double-click

    setIsClicked(true)
    if (!redirectUrl) return
    window.location.href = redirectUrl
  }, [isClicked, redirectUrl])

  if (!redirectUrl) return null

  return (
    <div className="mt-6 flex flex-col pb-6 sm:w-full md:w-1/2 lg:w-1/3 gap-4">
      <div>
        <h4 className="mb-2 text-xl font-bold text-gray-800">Confirm Signup</h4>
        <p>Click the button to confirm signing up to SID.</p>
      </div>

      <button
        onClick={handleConfirm}
        disabled={isClicked}
        className={`rounded border-2 py-2 px-2 text-center transition-colors ${
          isClicked
            ? 'bg-gray-200 border-gray-300 text-gray-500 cursor-not-allowed'
            : 'border-serblue-light bg-white hover:bg-gray-50'
        }`}
      >
        {isClicked ? 'Processing...' : 'Confirm'}
      </button>
    </div>
  )
}

export const Route = createFileRoute('/auth/confirm-signup')({
  component: ConfirmSignupPage,
})
